module.exports = __webpack_public_path__ + "elephant_ui_greeting-475430963d0b00fe82b07b17857ebf6c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/elephant_ui_greeting.svg
// module id = 257
// module chunks = 86